import { todaysDateString} from "../../utils/date-functions";
export class NewLog {
    public constructor(init?: Partial<NewLog>) {
        Object.assign(this, init);
}

    poNumber!: string;
    vendor?: string;
    jobNumber?: string;
    jobName?: string;
    jcDept?: string;
    type?: string;
    qtyUnits?: string;
    shelfLocation!: string;
    shopSqFt?: number;
    estimatedDateOut?: Date;
    notify?: string;
    contact?: string;
    items?: string;
    notes?: string;
    dateIn: string = todaysDateString();
    printLabel: boolean= true;
    printType?:string;
    printQtySheet: number=1;
    printQtyDymo: number=2;
   
}

